import React                            from "react";
import PropTypes                        from 'prop-types';
import {render, unmountComponentAtNode} from 'react-dom';
import Modal       from './Modal';
import PjaxWrapper from "../utils/PjaxWrapper";

class ModalBoxContent extends React.Component {
	render() {
		const {render: renderFn, children: child} = this.props;
		return renderFn
			? renderFn(this.props)
			: React.cloneElement(React.Children.only(child), this.props);
	}
}

ModalBoxContent.propTypes = {
	children: PropTypes.node,
	closeFn:  PropTypes.func,
	render:   PropTypes.func,
};

class ModalBox extends React.Component {

	static getRawMarkup(text) {
		return {
			__html: text,
		};
	}

	constructor(props) {
		super(props);

		this.refModal = null;

		this.getRef           = this.getRef.bind(this);
		this.onOK             = this.onOK.bind(this);
		this.onCancel         = this.onCancel.bind(this);
		this.onClose          = this.onClose.bind(this);
		this.onContainerClick = this.onContainerClick.bind(this);
		this.close            = this.close.bind(this);
	}

	onOK() {
		if (typeof this.props.onOK === 'function') {
			this.props.onOK(this);
		}
	}

	onCancel() {
		if (typeof this.props.onCancel === 'function') {
			this.props.onCancel(this);
		}
	}

	onClose() {
		if (typeof this.props.onClose === 'function') {
			this.props.onClose(this);
		}
	}

	close() {
		if (this.refModal) {
			this.refModal.onCloseClick();
		}
	}

	onContainerClick() {
		this.props.onContainerClickFn(this);
	}

	getRef(ref) {
		if (ref) {
			this.refModal = ref;
		}
	}

	render() {
		const modalClassName = '-theme-dialog' + (this.props.modalClassName ? ' ' + this.props.modalClassName : '');
		return (
			<Modal ref={this.getRef}
			       containerWidth={this.props.initialWidth}
			       containerHeight={this.props.initialHeight}
			       onClose={this.onClose}
			       className={modalClassName}
			       hideCloseButton={this.props.hideCloseButton}
			       onContainerClickFn={this.onContainerClick}
			>
				<ModalBoxContent closeFn={this.close} okFn={this.onOK}>{this.props.children}</ModalBoxContent>
			</Modal>
		);
	}
}

ModalBox.propTypes = {
	children:           PropTypes.array,
	hideCloseButton:    PropTypes.bool,
	initialWidth:       PropTypes.number,
	initialHeight:      PropTypes.number,
	modalClassName:     PropTypes.string,
	onCancel:           PropTypes.func,
	onClose:            PropTypes.func,
	onContainerClickFn: PropTypes.func,
	onOK:               PropTypes.func,
};

ModalBox.defaultProps = {
	onContainerClickFn: () => {
	},
	hideCloseButton:    false,
	initialWidth:       500,
	initialHeight:      500,
};

/**
 * @param content
 * @param modalBoxProps
 * @param onClose
 */
function openModalBox(content, modalBoxProps, onClose) {
	const elemId = 'modalbox-dialog';
	let el       = document.getElementById(elemId);

	if (!el) {
		el    = document.createElement('div');
		el.id = elemId;
		document.body.appendChild(el);
	}

	render(<ModalBox onClose={onClose} {...modalBoxProps}>
		{content}
	</ModalBox>, el);

	PjaxWrapper.addUnloadFunc(() => {
		unmountComponentAtNode(el);
	});
}

export {
	openModalBox,
	ModalBox,
};
